export const equalsLanguageCode = (firstLangConde = '', secondLangCode = '') =>
  firstLangConde.toLowerCase() === secondLangCode.toLowerCase();
